import { useState } from 'react';
import { useRouter } from 'next/router';
import styles from '@features/footer/components/LanguageSelect/LanguageSelect.styles';
import Icon from '@components/icons/Icon';
import { IRegionData, IRegionDataLanguage, TLocale } from '@typescript/index';
import Add3 from '@components/icons/components/Add3';
import Minus3 from '@components/icons/components/Minus3';
import EcCart2 from '@components/icons/components/EcCart2';
import { useRegionsStore } from '@features/footer/components/LanguageSelect/mobX/context/RegionStoreProvider';
type PropsType = {
  region: IRegionData;
  currentOffer: string | null;
  currentLocale: TLocale | null;
};
const CountryListItem = ({
  region,
  currentOffer,
  currentLocale
}: PropsType) => {
  const router = useRouter();
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    closeSidebar,
    setExternalLanguage
  } = useRegionsStore();
  const sameOffer = currentOffer === region.offer;
  const onLanguageChange = async (language: IRegionDataLanguage) => {
    const isTheSameDomain = language.url.includes(window.location.hostname);
    if (isTheSameDomain && !(language.url.includes('old.vox.pl') || language.url.includes('vox.pl/global'))) {
      await setExternalLanguage(language);
      closeSidebar();
      router.push('/', '/', {
        locale: language.locale
      });
    } else {
      window.location.replace(language.url);
    }
  };
  return <li key={region.name} sx={styles.countryListItem}>
      <button sx={styles.regionButton} type="button" onClick={() => setIsExpanded(prev => !prev)}>
        <span sx={styles.buttonText}>
          {region.name}{' '}
          {region.sale && <Icon size="24px" addSx={styles.buttonIcon}>
              <EcCart2 />
            </Icon>}
        </span>
        <Icon size="18px" padding="3px">
          {isExpanded ? <Minus3 /> : <Add3 />}
        </Icon>
      </button>
      {isExpanded && region.languages.length > 0 && <div sx={styles.languageListWrapper}>
          {region.languages.map(language => <button type="button" sx={styles.languageListItem(sameOffer && language.locale === currentLocale)} onClick={() => {
        onLanguageChange(language);
      }} key={`${language.code}-${Math.random()}`}>
              {language.name}{' '}
              {language.sale && <Icon size="18px" addSx={styles.buttonIcon}>
                  <EcCart2 />
                </Icon>}
            </button>)}
        </div>}
    </li>;
};
export default CountryListItem;